import React from "react";
import {useDispatch, useSelector} from "react-redux";
import {push} from "react-router-redux";

// TODO: Refactor - replace admissionListNavigation
const useBookingListNavigation = (items, config = null) => {
    const dispatch = useDispatch();
    const {status, keyword, sortColumn, sortMode, page, date} = useSelector(state => state.bookingList); // TODO: abstract list?
    const {selectedHospital} = useSelector(state => state.auth);

    const pushBookingListUrl = (newHospitalId = null, newStatus = null, newKeyword = null, newSortColumn = null, newSortMode = null, newDate = null, newPage = null) => {
        newHospitalId = newHospitalId !== null ? newHospitalId : selectedHospital.id;
        newStatus = (newStatus !== null && newStatus !== undefined) ? newStatus : status;
        newKeyword = newKeyword !== null ? newKeyword : keyword;
        newSortColumn = newSortColumn !== null ? newSortColumn : sortColumn;
        newSortMode = newSortMode !== null ? newSortMode : sortMode;
        newDate = newDate !== null ? newDate : date;
        newPage = newPage !== null ? newPage : page;

        // TODO: Refactor replace discharge with custom prefix?
        if (newStatus) {
            dispatch(push(`/bookings/${newStatus}`));
        } else if (newKeyword) {
            dispatch(push(`/bookings/search/${newKeyword}`))
        } else {
            dispatch(push(`/bookings/${newStatus}/${newSortColumn}/${newSortMode}`))
        }
    }

    const isFilterPersisted = false;
    return { pushBookingListUrl, isFilterPersisted }
}

export default useBookingListNavigation;